import styled from 'styled-components'
import { NotificationBadge } from '@/features/shared/components/NotificationBadge'
import { TextButton } from '@shipt/design-system-buttons'
import { screenSizes } from '@shipt/design-system-themes'
import { FilterIcon } from '@shipt/design-system-icons'
import { Box } from '@shipt/design-system-layouts'

type Props = {
  onClick: () => void
  activeFiltersLength: number
}

export const MobileFilterButton = ({ onClick, activeFiltersLength }: Props) => (
  <Box padding={['md']}>
    <Button aria-label="refine search" onClick={onClick}>
      <NotificationBadge
        value={activeFiltersLength}
        aria-label={`${activeFiltersLength} filters applied`}
      >
        <FilterIcon />
      </NotificationBadge>
    </Button>
  </Box>
)

const Button = styled(TextButton)`
  margin: -0.75rem 0 -0.875rem;

  @media ${screenSizes.tablet} {
    display: none;
  }
`
